import { render } from "./NewAsideDefesaCivil.vue?vue&type=template&id=f28e12c0&scoped=true"
import script from "./NewAsideDefesaCivil.vue?vue&type=script&lang=js"
export * from "./NewAsideDefesaCivil.vue?vue&type=script&lang=js"

import "./NewAsideDefesaCivil.vue?vue&type=style&index=0&id=f28e12c0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f28e12c0"]])

export default __exports__